import type { Position } from "../types";
import { price, money2, utcTime, sideLabel } from "../format";

export default function PositionPanel({ position }: { position?: Position | null }) {
  if (!position) {
    return (
      <div className="position flat" role="status">
        <span className="pos-dot" aria-hidden="true">●</span>
        <strong>Flat</strong> — no open position right now.
      </div>
    );
  }
  const long = (position.side ?? 0) > 0;
  const u = position.unrealized_pnl;
  return (
    <div className={`position ${long ? "long" : "short"}`} role="group" aria-label="Open position">
      <div className="pos-head">
        <span className={`side-pill ${long ? "long" : "short"}`}>
          {long ? "▲ LONG" : "▼ SHORT"}
        </span>
        <span className="pos-sub">open since {utcTime(position.entry_time)}</span>
      </div>
      <dl className="pos-grid">
        <div><dt>Entry price</dt><dd>{price(position.entry_price)}</dd></div>
        <div><dt>Current</dt><dd>{price(position.last_price)}</dd></div>
        <div><dt>Stop-loss</dt><dd className="sl">{price(position.sl)}</dd></div>
        <div><dt>Take-profit</dt><dd className="tp">{price(position.tp)}</dd></div>
        <div><dt>Size (oz)</dt><dd>{position.size_oz?.toFixed(2)}</dd></div>
        <div>
          <dt>Unrealized P&amp;L</dt>
          <dd className={u == null ? "" : u >= 0 ? "win" : "loss"}>
            {u == null ? "—" : money2(u)}
          </dd>
        </div>
      </dl>
    </div>
  );
}
